export const sampleLibrary = {
    "sampler": [
        {
            "name": "80sdx",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/80sdx.wav"
        },
        {
            "name": "accordion",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/accordion.wav"
        },
        {
            "name": "adagio strings",
            "scale": "a:minor",
            "url": "/static/dist/public/audio/sampler/adagio strings.wav"
        },
        {
            "name": "anguish",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/anguish.wav"
        },
        {
            "name": "arpa",
            "scale": "eb:major",
            "url": "/static/dist/public/audio/sampler/arpa.wav"
        },
        {
            "name": "bass-synth",
            "scale": "f:minor",
            "url": "/static/dist/public/audio/sampler/bass-synth.wav"
        },
        {
            "name": "casaencantada",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/casaencantada.wav"
        },
        {
            "name": "cello suite",
            "scale": "eb:major",
            "url": "/static/dist/public/audio/sampler/cello suite.wav"
        },
        {
            "name": "classico",
            "scale": "f#:minor",
            "url": "/static/dist/public/audio/sampler/classico.wav"
        },
        {
            "name": "dark pianos",
            "scale": "g:locrian",
            "url": "/static/dist/public/audio/sampler/dark pianos.wav"
        },
        {
            "name": "darksynth",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/darksynth.wav"
        },
        {
            "name": "funkbass",
            "scale": "a:major",
            "url": "/static/dist/public/audio/sampler/funkbass.wav"
        },
        {
            "name": "gsynth",
            "scale": "bb:major",
            "url": "/static/dist/public/audio/sampler/gsynth.wav"
        },
        {
            "name": "guit&delayfx",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/guit&delayfx.wav"
        },
        {
            "name": "guit-nostalgia",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/guit-nostalgia.wav"
        },
        {
            "name": "guitarra",
            "scale": "c:major",
            "url": "/static/dist/public/audio/sampler/guitarra.wav"
        },
        {
            "name": "guitarra2",
            "scale": "b:wholetone",
            "url": "/static/dist/public/audio/sampler/guitarra2.wav"
        },
        {
            "name": "guitcolo",
            "scale": "e:major",
            "url": "/static/dist/public/audio/sampler/guitcolo.wav"
        },
        {
            "name": "indiachant",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/indiachant.wav"
        },
        {
            "name": "industrial-noise",
            "scale": "c:minor",
            "url": "/static/dist/public/audio/sampler/industrial-noise.wav"
        },
        {
            "name": "jazz loop",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/jazz loop.wav"
        },
        {
            "name": "jazz riff",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/jazz riff.wav"
        },
        {
            "name": "korridor",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/korridor.wav"
        },
        {
            "name": "loop basss- accordion",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/loop basss- accordion.wav"
        },
        {
            "name": "loop fluteguit",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/loop fluteguit.wav"
        },
        {
            "name": "loop synth",
            "scale": "f#:minor",
            "url": "/static/dist/public/audio/sampler/loop synth.wav"
        },
        {
            "name": "loop tuba",
            "scale": "c:major",
            "url": "/static/dist/public/audio/sampler/loop tuba.wav"
        },
        {
            "name": "loop-guitarra",
            "scale": "f:minor",
            "url": "/static/dist/public/audio/sampler/loop-guitarra.wav"
        },
        {
            "name": "loop-piano01",
            "scale": "f:minor",
            "url": "/static/dist/public/audio/sampler/loop-piano01.wav"
        },
        {
            "name": "loop-piano02",
            "scale": "db:major",
            "url": "/static/dist/public/audio/sampler/loop-piano02.wav"
        },
        {
            "name": "loop-rhodes",
            "scale": "eb:major",
            "url": "/static/dist/public/audio/sampler/loop-rhodes.wav"
        },
        {
            "name": "loopfunk",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/loopfunk.wav"
        },
        {
            "name": "loopfunkbass",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/loopfunkbass.wav"
        },
        {
            "name": "loopguitarra",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/loopguitarra.wav"
        },
        {
            "name": "loopsoul halftruths",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/loopsoul halftruths.wav"
        },
        {
            "name": "lucianovox",
            "scale": "d:major",
            "url": "/static/dist/public/audio/sampler/lucianovox.wav"
        },
        {
            "name": "medievo",
            "scale": "e:major",
            "url": "/static/dist/public/audio/sampler/medievo.wav"
        },
        {
            "name": "met\u00e1 met\u00e1",
            "scale": "eb:minor",
            "url": "/static/dist/public/audio/sampler/met\u00e1 met\u00e1.wav"
        },
        {
            "name": "nero sud",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/nero sud.wav"
        },
        {
            "name": "nostalgia",
            "scale": "d:minor",
            "url": "/static/dist/public/audio/sampler/nostalgia.wav"
        },
        {
            "name": "november rains",
            "scale": "eb:minor",
            "url": "/static/dist/public/audio/sampler/november rains.wav"
        },
        {
            "name": "nuovogiorno",
            "scale": "e:minor",
            "url": "/static/dist/public/audio/sampler/nuovogiorno.wav"
        },
        {
            "name": "olho do lago",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/olho do lago.wav"
        },
        {
            "name": "orient flute",
            "scale": "ab:harmonic minor",
            "url": "/static/dist/public/audio/sampler/orient flute.wav"
        },
        {
            "name": "padflute",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/padflute.wav"
        },
        {
            "name": "palermo",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/palermo.wav"
        },
        {
            "name": "pastor champion",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/pastor champion.wav"
        },
        {
            "name": "piano & bass 02",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/piano & bass 02.wav"
        },
        {
            "name": "piano",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/piano.wav"
        },
        {
            "name": "piano chords",
            "scale": "ab:major",
            "url": "/static/dist/public/audio/sampler/piano chords.wav"
        },
        {
            "name": "piano fx",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/piano fx.wav"
        },
        {
            "name": "piano&bass",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/piano&bass.wav"
        },
        {
            "name": "piano&guitar",
            "scale": "d:major",
            "url": "/static/dist/public/audio/sampler/piano&guitar.wav"
        },
        {
            "name": "piano&perc",
            "scale": "db:major",
            "url": "/static/dist/public/audio/sampler/piano&perc.wav"
        },
        {
            "name": "piano-chords",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/piano-chords.wav"
        },
        {
            "name": "rhodes",
            "scale": "d:major",
            "url": "/static/dist/public/audio/sampler/rhodes.wav"
        },
        {
            "name": "sad pianos",
            "scale": "c:minor",
            "url": "/static/dist/public/audio/sampler/sad pianos.wav"
        },
        {
            "name": "samba lenta",
            "scale": "c:major",
            "url": "/static/dist/public/audio/sampler/samba lenta.wav"
        },
        {
            "name": "see you again",
            "scale": "f#:minor",
            "url": "/static/dist/public/audio/sampler/see you again.wav"
        },
        {
            "name": "sidechainen vocals",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/sidechainen vocals.wav"
        },
        {
            "name": "sitar",
            "scale": "c#:harmonic minor",
            "url": "/static/dist/public/audio/sampler/sitar.wav"
        },
        {
            "name": "solitudini",
            "scale": "b:minor",
            "url": "/static/dist/public/audio/sampler/solitudini.wav"
        },
        {
            "name": "soulguitar01",
            "scale": "bb:major",
            "url": "/static/dist/public/audio/sampler/soulguitar01.wav"
        },
        {
            "name": "soulguitar02",
            "scale": "d:locrian",
            "url": "/static/dist/public/audio/sampler/soulguitar02.wav"
        },
        {
            "name": "spectralsynth",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/spectralsynth.wav"
        },
        {
            "name": "strings&saxo",
            "scale": "g:major",
            "url": "/static/dist/public/audio/sampler/strings&saxo.wav"
        },
        {
            "name": "synth",
            "scale": "ab:minor",
            "url": "/static/dist/public/audio/sampler/synth.wav"
        },
        {
            "name": "synth$strings",
            "scale": "bb:major",
            "url": "/static/dist/public/audio/sampler/synth$strings.wav"
        },
        {
            "name": "synth-fx",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/synth-fx.wav"
        },
        {
            "name": "synth-strings",
            "scale": "a:major",
            "url": "/static/dist/public/audio/sampler/synth-strings.wav"
        },
        {
            "name": "synts-trompes",
            "scale": "f:major",
            "url": "/static/dist/public/audio/sampler/synts-trompes.wav"
        },
        {
            "name": "tension",
            "scale": "c:minor",
            "url": "/static/dist/public/audio/sampler/tension.wav"
        },
        {
            "name": "toy piano",
            "scale": "f#:major",
            "url": "/static/dist/public/audio/sampler/toy piano.wav"
        },
        {
            "name": "trap",
            "scale": "bb:minor",
            "url": "/static/dist/public/audio/sampler/trap.wav"
        },
        {
            "name": "undone",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/undone.wav"
        },
        {
            "name": "vents",
            "scale": "g:locrian",
            "url": "/static/dist/public/audio/sampler/vents.wav"
        },
        {
            "name": "veus misteri",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/veus misteri.wav"
        },
        {
            "name": "vibes ambient",
            "scale": "c#:minor",
            "url": "/static/dist/public/audio/sampler/vibes ambient.wav"
        },
        {
            "name": "vocals",
            "scale": "e:major",
            "url": "/static/dist/public/audio/sampler/vocals.wav"
        },
        {
            "name": "whitelotus",
            "scale": "g:minor",
            "url": "/static/dist/public/audio/sampler/whitelotus.wav"
        },
        {
            "name": "windyvocal",
            "scale": "b:major",
            "url": "/static/dist/public/audio/sampler/windyvocal.wav"
        }
    ],
    "groovebox": [
        {
            "name": "Funky Soul-kick",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Kick Funky Soul.wav"
        },
        {
            "name": "Funky Soul-closedHat",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Closed Hat Funky Soul.wav"
        },
        {
            "name": "Funky Soul-snare",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Snare Funky Soul.wav"
        },
        {
            "name": "Funky Soul-openHat",
            "url": "/static/dist/public/audio/groovebox/Funky Soul/Open Hat Funky Soul.wav"
        },
        {
            "name": "Hip hop Classic 2-closedHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Closed Hat HipHop Classic 2.wav"
        },
        {
            "name": "Hip hop Classic 2-openHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Open Hat HipHop Classic 2.wav"
        },
        {
            "name": "Hip hop Classic 2-kick",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Kick HipHop Classic 2.wav"
        },
        {
            "name": "Hip hop Classic 2-snare",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 2/Snare HipHop Classic 2.wav"
        },
        {
            "name": "Trap 2-openHat",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Open Hat Trap 2.wav"
        },
        {
            "name": "Trap 2-kick",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Kick Trap 2.wav"
        },
        {
            "name": "Trap 2-snare",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Snare Trap 2.wav"
        },
        {
            "name": "Trap 2-closedHat",
            "url": "/static/dist/public/audio/groovebox/Trap 2/Closed Hat Trap 2.wav"
        },
        {
            "name": "Hip hop Classic 1-openHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Open Hat HipHop Classic 1.wav"
        },
        {
            "name": "Hip hop Classic 1-kick",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Kick HipHop Classic 1.wav"
        },
        {
            "name": "Hip hop Classic 1-closedHat",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Closed Hat HipHop Classic 1.wav"
        },
        {
            "name": "Hip hop Classic 1-snare",
            "url": "/static/dist/public/audio/groovebox/Hip hop Classic 1/Snare HipHop Classic 1.wav"
        },
        {
            "name": "Trap 1-snare",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Clap  Trap 1.wav"
        },
        {
            "name": "Trap 1-closedHat",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Closed hat Trap 1.wav"
        },
        {
            "name": "Trap 1-kick",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Kick Trap 1.wav"
        },
        {
            "name": "Trap 1-openHat",
            "url": "/static/dist/public/audio/groovebox/Trap 1/Open Hat trap 1.wav"
        },
        {
            "name": "Urban reggaeton-snare",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Snare Urban Reggaeton.wav"
        },
        {
            "name": "Urban reggaeton-kick",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Kick Urban Reggaeton.wav"
        },
        {
            "name": "Urban reggaeton-openHat",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Woodblock Urban Reggaeton.wav"
        },
        {
            "name": "Urban reggaeton-closedHat",
            "url": "/static/dist/public/audio/groovebox/Urban reggaeton/Closed Hat Urban Reggaeton.wav"
        },
        {
            "name": "Soul Pop-kick",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Kick Soul Pop.wav"
        },
        {
            "name": "Soul Pop-openHat",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Tambourine Soul Pop.wav"
        },
        {
            "name": "Soul Pop-closedHat",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Closed Hat Soul Pop.wav"
        },
        {
            "name": "Soul Pop-snare",
            "url": "/static/dist/public/audio/groovebox/Soul Pop/Snare Soul Pop.wav"
        },
        {
            "name": "Dub Reggae-closedHat",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Closed Hat Dub Reggae.wav"
        },
        {
            "name": "Dub Reggae-kick",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Kick Dub Reggae.wav"
        },
        {
            "name": "Dub Reggae-snare",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Snare Dub Reggae.wav"
        },
        {
            "name": "Dub Reggae-openHat",
            "url": "/static/dist/public/audio/groovebox/Dub Reggae/Open Hat Dub Reggae.wav"
        },
        {
            "name": "Acid house-snare",
            "url": "/static/dist/public/audio/groovebox/Acid house/Clap Acid House.wav"
        },
        {
            "name": "Acid house-kick",
            "url": "/static/dist/public/audio/groovebox/Acid house/Kick Acid House.wav"
        },
        {
            "name": "Acid house-openHat",
            "url": "/static/dist/public/audio/groovebox/Acid house/Open Hat Acid House.wav"
        },
        {
            "name": "Acid house-closedHat",
            "url": "/static/dist/public/audio/groovebox/Acid house/Closed Hat Acid House.wav"
        },
        {
            "name": "Reggae Roots-closedHat",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Closed Hat Reggae Roots.wav"
        },
        {
            "name": "Reggae Roots-snare",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Snare Reggae Roots.wav"
        },
        {
            "name": "Reggae Roots-openHat",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Open Hat Reggae roots.wav"
        },
        {
            "name": "Reggae Roots-kick",
            "url": "/static/dist/public/audio/groovebox/Reggae Roots/Kick Reggae Roots.wav"
        }
    ]
}